import { useState, type ReactNode } from "react";

interface Props {
  title: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function CollapsibleSection({ title, defaultOpen = false, children }: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="form-section">
      <button
        type="button"
        className="form-section-header"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span>{title}</span>
        <span className="form-section-toggle">{open ? "▲" : "▼"}</span>
      </button>
      <div className={`form-section-body${open ? "" : " hidden"}`}>{children}</div>
    </div>
  );
}
